import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import SettingsPage from "@/pages/SettingsPage";
import Billing from "@/pages/Billing";
import Connexion from "@/pages/Connexion";
import { SectorsIndex, SectorDetail } from "@/pages/Sectors";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/connexion" element={<Connexion />} />
      <Route path="/secteurs" element={<SectorsIndex />} />
      <Route path="/secteurs/:niche" element={<SectorDetail />} />
      <Route path="/secteurs/:niche/:dep" element={<SectorDetail />} />
      <Route path="/onboarding" element={<ProtectedRoute requireOnboarded={false} requirePlan={false}><Onboarding /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/reglages" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="/abonnement" element={<ProtectedRoute requirePlan={false}><Billing /></ProtectedRoute>} />
      <Route path="/payment/success" element={<ProtectedRoute requireOnboarded={false} requirePlan={false}><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/payment/cancel" element={<ProtectedRoute requireOnboarded={false} requirePlan={false}><PaymentCancel /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
